const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const URLMake = require("../../../shared/URLMake");
const OpsUser = require("../../core/vault/OpsUser");
const AT = require("../../core/vault/ActionTypes");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const Link = require("../../core/view/Link");
const Cart = require("./Cart");
const {getFeatureFlag} = require("../../core/util/FeatureFlags");
const {track} = require("../../core/util/Mixpanel");
const OrderSummary = require("./OrderSummary");
const Suggestions = require("./Suggestions");
const OpsCart = require("../vault/OpsCart");
const StoreUtil = require("../../../shared/StoreUtil");
const CopyTable = require("../data/CopyTable");
const {ChooseOptionModal} = require("../modals/ChooseOptionModal");
const CartItemIcon = require("./CartItemIcon");
const {BundleConversionModal} = require("./BundleConversionModal");
const {Info} = require("lucide-react");

const styles = require("./styles/ReviewCart.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "CheckoutReview",

		propTypes: {
			user: PT.object.isRequired,
			cart: PT.object.isRequired,
			onContinue: PT.func,
			step: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			checkoutLockedForLoggedIn: function() {
				this.showSubsWarning();
			},
			bundleConverted: function(newCart) {
				if (!OpsCart.canConvertBundle(newCart.items)) {
					this.setState({showBundleModal: false});
				}
			},
		},

		getInitialState: function() {
			return {
				cartHadItems: !OpsCart.isEmpty(this.props.cart),
				showBundleModal: false,
				showSuggestModal: false,
			};
		},

		componentDidMount: function() {
			track("Cart Page View for A/A Test", {
				aaTestVariant: getFeatureFlag("CART_PAGE_AA_TEST"),
			});
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			if (!this.state.cartHadItems && !OpsCart.isEmpty(nextProps.cart)) {
				this.setState({cartHadItems: true});
			}
		},

		canBuySubscriptions: function(user) {
			// Guests and non-initialized BA users can buy subscriptions via normal
			// checkout.
			return (
				!OpsUser.isLoggedIn(user) ||
				(OpsUser.isPlatformGuest(user) &&
					!OpsUser.isRestrictedPlatformUser(user))
			);
		},

		showSubsWarning: function() {
			const {user, cart} = this.props;
			const isParent = OpsUser.hasParentRole(user);
			const itemsWithBundles = OpsCart.getItemsWithBundles(cart.items);
			this.props.dispatch({
				type: AT.SHOW_OFFICE_MESSAGE,
				messageType: "subsThruAccount",
				extraInfo: {
					role: isParent ? "parent" : "other",
					hasBooks: OpsCart.hasBookItems(itemsWithBundles),
				},
			});
		},

		onContinue: function() {
			const {user, cart} = this.props;
			if (
				!this.canBuySubscriptions(user) &&
				OpsCart.hasSubscriptionItems(cart.items)
			) {
				this.showSubsWarning();
			} else if (OpsCart.canConvertBundle(cart.items)) {
				this.setState({showBundleModal: true});
			} else if (OpsCart.canSuggestBundle(cart.items)) {
				this.setState({showSuggestModal: true});
			} else {
				this.props.onContinue();
			}
		},

		closeBundleModal: function() {
			this.setState({showBundleModal: false});
		},

		closeSuggestModal: function() {
			this.setState({showSuggestModal: false});
		},

		makeBundle: function(selectOptionState) {
			let bundleID = selectOptionState.selected;
			// subscriptionKey will be the name of a named subscription or "beast-bulk-codes"
			const subscriptionKey = selectOptionState.additionalSelected;
			// bundles that contain a different subscription SKU will have the SKU
			// appended to the bundleID
			// e.g. bundle-grade-1 (contains beast-yearly) vs
			// bundle-grade-1-beast-bulk-codes (contains beast-bulk-codes)
			if (subscriptionKey === "beast-bulk-codes") {
				bundleID = `${bundleID}-${subscriptionKey}`;
			}
			this.props.dispatch({
				type: AT.CONVERT_BUNDLE,
				subscriptionKey,
				bundleID,
			});
		},

		bundleSuggestion: function() {
			this.setState({showBundleModal: false});
			this.props.dispatch({
				type: AT.CONVERT_SUGGESTED_BUNDLE,
			});
		},

		render: function() {
			let cartEl;
			const {cart, user, step} = this.props;

			if (!this.state.cartHadItems && OpsCart.isEmpty(cart)) {
				cartEl = (
					<div className={styles.empty}>
						<div className={styles.text}>Your cart is currently empty.</div>
						<div className={styles.browseBooks}>
							<Link to={URLMake.forEnroll()} className={styles.button}>
								Browse BA Online
							</Link>
							<Link to={URLMake.forBookCollections()} className={styles.button}>
								Browse Books
							</Link>
						</div>
					</div>
				);
			} else {
				let subscriptionsErrorType;
				if (!this.canBuySubscriptions(user)) {
					subscriptionsErrorType = OpsUser.hasParentRole(user)
						? "parent"
						: "other";
				}
				const hasDeferredBundle = StoreUtil.hasDeferredBundleSubscriptions(
					cart.items
				);
				cartEl = (
					<>
						<Cart
							cart={cart}
							tabIndexStart={1}
							subscriptionsErrorType={subscriptionsErrorType}
							step={step}
						/>
						{hasDeferredBundle && (
							<div className={styles.deferredBundleNotice}>
								<Info
									className={styles.deferredBundleNoticeIcon}
									size={24}
									aria-hidden={true}
								/>
								<div className={styles.deferredBundleNoticeText}>
									{"Take the placement test during onboarding."}
									<br className={styles.deferredBundleNoticeBreak} />
									{
										" You'll have 48 hours to confirm or update pending books before they're processed."
									}
								</div>
							</div>
						)}
					</>
				);
			}

			let bundleModal;
			let suggestModal;
			if (this.state.showBundleModal) {
				bundleModal = (
					<BundleConversionModal
						cart={cart}
						makeBundle={this.makeBundle}
						onClose={this.closeBundleModal}
					/>
				);
			} else if (
				this.state.showSuggestModal &&
				OpsCart.canSuggestBundle(cart.items)
			) {
				const unbundledBooks = OpsCart.getOrderedUnbundledBooks(cart.items)[0];
				const unbundledSub = OpsCart.getOrderedUnbundledSubscriptions(
					cart.items
				)[0];
				const missingBooks = unbundledBooks.missingSkus.map(
					OpsCart.getNameFromSKU
				);
				const subName = unbundledSub.options.displayName;
				const gradeNumber = unbundledBooks.gradeNumber;

				const currSubtotal = OpsCart.calculateSubtotal(cart.items);
				const cartCopy = _.cloneDeep(cart);
				const futureCart = OpsCart.convertSuggestedBundle(cartCopy);
				const futureItems = futureCart.items;
				const futureSubtotal = OpsCart.calculateSubtotal(futureItems);

				const message = (
					<div>
						{CopyTable.getSuggestBundleCopy({
							missingBooks,
							priceDiff: futureSubtotal.minus(currSubtotal).toFixed(0),
							subName,
							gradeNumber,
						})}
						<div className={styles.bundle}>
							<CartItemIcon
								className={styles.bundleIcon}
								itemType="bundle"
								itemDetails={{level: gradeNumber}}
							/>
						</div>
					</div>
				);

				suggestModal = (
					<ChooseOptionModal
						title={"Bundle and Save"}
						message={message}
						buttonTexts={["bundle", "no thanks"]}
						buttonClickHandlers={[this.bundleSuggestion, this.props.onContinue]}
						onClose={this.closeSuggestModal}
					/>
				);
			}

			const buttonText = "Continue";

			const suggestions = OpsCart.hasOnlySubscriptionCodeItems(
				cart.items
			) ? null : (
				<Suggestions
					cart={cart}
					className={styles.suggestions}
					tabIndexStart={1000}
				/>
			);

			return (
				<div className={styles.main}>
					<div className={styles.content}>
						<div className={styles.title}>{"Cart"}</div>
						<div className={styles.across}>
							<div className={styles.formContainer}>{cartEl}</div>
							<OrderSummary
								cart={cart}
								onContinue={this.onContinue}
								buttonText={buttonText}
								paypalButtonText={"Continue with"}
								showItemize={true}
								tabIndex={500}
								step={step}
							/>
						</div>
						{suggestions}
					</div>
					{bundleModal}
					{suggestModal}
				</div>
			);
		},
	})
);
